import { useQuery } from '@tanstack/react-query';

import { getOrderTransactionStatus } from '~/services/OrdersService';

export const orderTransactionStatusQueryKeys = {
  all: ['order-transaction-status'] as const,
  detail: (statusHref: string) => [...orderTransactionStatusQueryKeys.all, statusHref] as const,
};

export function useGetOrderTransactionStatus(statusHref: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: statusHref ? orderTransactionStatusQueryKeys.detail(statusHref) : orderTransactionStatusQueryKeys.all,
    queryFn: () => {
      if (!statusHref) {
        throw new Error('Order transaction status link is required');
      }

      return getOrderTransactionStatus(statusHref);
    },
    enabled: enabled && Boolean(statusHref),
  });
}
